import { Injectable } from '@angular/core';
import { CardapioFreteDTO } from '../../models/cardapio-digital/cardapio-digital.model';
import { TipoPedido } from '../../enums/TipoPedido.enum';

/**
 * Servico para calculo de frete no cardapio digital.
 * Usa a configuracao de frete retornada pelo endpoint publico.
 */
@Injectable({ providedIn: 'root' })
export class CardapioFreteService {

  /**
   * Calcula o valor do frete com base no subtotal, tipo de pedido e configuracao.
   * - Retirada e Mesa: frete 0
   * - Delivery sem configuracao de frete: frete 0
   * - Delivery com frete ativo: valor fixo (ou gratis acima do minimo)
   */
  calcularFrete(
    subtotal: number,
    tipoPedido: TipoPedido,
    freteConfig: CardapioFreteDTO | null | undefined
  ): number {
    // Retirada e Mesa nao tem frete
    if (tipoPedido !== TipoPedido.DELIVERY) return 0;

    // Sem configuracao de frete ou frete desativado
    if (!freteConfig || !freteConfig.ativo) return 0;

    // Frete gratis acima do valor minimo
    if (freteConfig.valorMinimoFreteGratis && subtotal >= freteConfig.valorMinimoFreteGratis) {
      return 0;
    }

    // Valor fixo
    return freteConfig.valorFixo || 0;
  }
}
